import { Reducer } from 'react';

import {
  ICatalogPayload, resPagination, resVacancies,
} from '../../utils/types/admin-types';
import {
  Action,
} from '../../utils/types/state-types';
import {
  GET_CATALOG_VACANCIES_RECEIVED,
  GET_CATALOG_VACANCIES_REJECTED,
  GET_CATALOG_VACANCIES_REQUESTED,
} from '../actions/admin-page';
import {
  isPagination, isVacancies,
} from './catalogReducer';

export interface ICatalogVacanciesReducerState {
  error?: string;
  vacancies: resVacancies | null,
  pagination: resPagination | null,
  isLoading: boolean;
}

const initialState = {
  vacancies: null,
  pagination: null,
  error: '',
  isLoading: false,
} as ICatalogVacanciesReducerState;

const catalogVacanciesReducer: Reducer<ICatalogVacanciesReducerState, Action> = (
  state = initialState,
  action: Action,
) => {
  const { type } = action;
  switch (type) {
    case GET_CATALOG_VACANCIES_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case GET_CATALOG_VACANCIES_RECEIVED: {
      const { payload } = action as Action<ICatalogPayload>;

      const result = {
        vacancies: payload.result.find((item) => {
          if (isVacancies(item)) {
            return item.category === 'vacancies';
          }

          return false;
        }) as resVacancies,
        pagination: payload.result.find((item) => {
          if (isPagination(item)) {
            return item.category === 'pagination';
          }

          return false;
        }) as resPagination,
      };

      return {
        ...state,
        isLoading: false,
        ...result,
        error: '',
      };
    }
    case GET_CATALOG_VACANCIES_REJECTED: {
      const { payload } = action as Action<ICatalogPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    default:
      return state;
  }
};

export default catalogVacanciesReducer;
